"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var mobx_1 = require("mobx");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Label_1 = __importDefault(require("./styledComponents/Label"));

var Icon_1 = __importDefault(require("./styledComponents/Icon"));

var Translate_1 = __importDefault(require("../Translate"));

var Checkbox_meta_1 = require("./Checkbox.meta");

var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];

var Checkbox =
/** @class */
function (_super) {
  __extends(Checkbox, _super);

  function Checkbox(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Checkbox_meta_1.CHECKBOX_CATEGORY_KEY;
    _this.componentKey = Checkbox_meta_1.CHECKBOX_COMPONENT_KEY;
    _this.checked = false;

    _this.onChange = function (event) {
      var _a = _this.props,
          disabled = _a.disabled,
          onChange = _a.onChange;

      if (!disabled) {
        _this.checked = !_this.checked;

        if (onChange) {
          onChange(event);
        }
      }
    };

    _this.handleKeyDown = function (e) {
      var key = e.key;

      if (ACCEPT_KEYS.indexOf(key) !== -1) {
        if (_this.inputReference) {
          _this.inputReference.click();
        }
      }
    };

    var value = _this.props.value;

    if (value) {
      _this.checked = value;
    }

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  Object.defineProperty(Checkbox.prototype, "defaultChecked", {
    get: function get() {
      return this.checked && this.checked === true;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Checkbox.prototype, "asset", {
    get: function get() {
      var icon = this.checked === 'half' ? 'half' : this.checked ? 'checked' : 'unchecked';
      return "base.checkbox." + icon;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Checkbox.prototype, "accessibilityText", {
    get: function get() {
      var icon = this.checked === 'half' ? 'half' : this.checked ? 'checked' : 'unchecked';
      return icon;
    },
    enumerable: true,
    configurable: true
  });

  Checkbox.prototype.assignReference = function (reference) {
    if (reference) {
      this.inputReference = reference;
    }
  };

  Checkbox.prototype.componentDidUpdate = function (previousProps) {
    var value = this.props.value;

    if (value !== undefined && previousProps.value !== value) {
      this.checked = value;
    }
  };

  Checkbox.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        disabled = _a.disabled,
        label = _a.label,
        labelId = _a.labelId,
        props = __rest(_a, ["className", "disabled", "label", "labelId"]);

    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Label_1.default, {
      role: "checkbox",
      "aria-checked": "mixed",
      tabIndex: 0,
      id: labelId,
      onKeyDown: function onKeyDown(event) {
        return _this.handleKeyDown(event);
      }
    }, react_1.default.createElement("input", {
      type: "checkbox",
      defaultChecked: this.defaultChecked,
      onChange: this.onChange,
      disabled: disabled,
      style: {
        display: 'none'
      },
      ref: function ref(reference) {
        return _this.assignReference(reference);
      }
    }), react_1.default.createElement(Icon_1.default, {
      asset: this.asset,
      "aria-label": this.accessibilityText
    }), react_1.default.createElement(Translate_1.default, null, label)));
  };

  __decorate([mobx_1.observable], Checkbox.prototype, "checked", void 0);

  Checkbox = __decorate([mobx_react_1.observer], Checkbox);
  return Checkbox;
}(shared_1.ComponentBase);

exports.Checkbox = Checkbox;
exports.default = shared_1.InjectedStyledComponent(Checkbox, Checkbox_meta_1.CHECKBOX_CATEGORY_KEY, Checkbox_meta_1.CHECKBOX_COMPONENT_KEY);